module.exports = __webpack_public_path__ + "img/undraw_among_nature_p1xb.0501fd63.svg";